import type { HookSavedData } from '@xing-com/crate-dream-machine-search-and-shuffle';

export const useYourJobsData: HookSavedData = () => {
  return {
    data: [],
    loading: false,
    error: undefined,
  };
};
